<div class="cg-dialog">
  <h3 class="cg-dialog__header cg-dialog__header--modal">
    {{ 'am.dialog.cancel.header' | translate }}
  </h3>
  <div>
    <p>{{ 'am.dialog.cancel.description' | translate }}</p>
  </div>
  <div class="cg-button-group cg-margin-top-lg">
    <button
      cignaButton="primary"
      data-test="wam-cancel-btn"
      (click)="cancelConfirm.emit()"
    >
      {{ 'am.dialog.cancel.yesBtn' | translate }}
    </button>
    <button
      data-test="wam-dont-cancel-btn"
      cignaButton="secondary"
      (click)="onNoClick()"
    >
      {{ 'am.dialog.cancel.noBtn' | translate }}
    </button>
  </div>
</div>
